/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {AddEventAttachmentsRequest} from "../model/add-event-attachments-request";
import {CopyEventRequest} from "../model/copy-event-request";
import {CopyEventResponse} from "../model/copy-event-response";
import {CreateAdHocEventResponse} from "../model/create-ad-hoc-event-response";
import {CreateDraftEventRequest} from "../model/create-draft-event-request";
import {CreateDraftEventResponse} from "../model/create-draft-event-response";
import {CreateEventRequest} from "../model/create-event-request";
import {DeleteBatchEventRequest} from "../model/delete-batch-event-request";
import {DeleteEventRequest} from "../model/delete-event-request";
import {Event} from "../model/event";
import {ExternalAvailabilityResponse} from "../model/external-availability-response";
import {GetEventDetailByIdResponse} from "../model/get-event-detail-by-id-response";
import {ListData} from "../model/list-data";
import {ListEventsRequest} from "../model/list-events-request";
import {RemoveEventAttachmentRequest} from "../model/remove-event-attachment-request";
import {RemoveEventAttachmentResponse} from "../model/remove-event-attachment-response";
import {SendEventEmailRequest} from "../model/send-event-email-request";
import {SessionState} from "../model/session-state";
import {SimSession} from "../model/sim-session";
import {SuccessResponse} from "../model/success-response";
import {UpdateEventNameRequest} from "../model/update-event-name-request";
import {UpdateOwnerOfEventRequest} from "../model/update-owner-of-event-request";
import {UpSertEventRequest} from "../model/up-sert-event-request";
import {UpSertEventStateRequest} from "../model/up-sert-event-state-request";
import {ValidateUpSertEventRequest} from "../model/validate-up-sert-event-request";

@Injectable({
    providedIn: "root",
})
export class SimEventService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public addAttachments(request: AddEventAttachmentsRequest) {
        return super.post<SuccessResponse>(`/api/Event/AddAttachments`, request);
    }

    public addSessionToEvent(eventId: string, sessionId: string) {
        return super.post<void>(`/api/Event/AddSessionToEvent/${encodeURIComponent(eventId)}/add-session/${encodeURIComponent(sessionId)}`, {});
    }
/**
 * Checks if the entire event's external resources are available in the given time range. Full check of calendar entries.
 */ 

    public checkExternalEventSchedule(eventId: string) {
        return super.get<ExternalAvailabilityResponse>(`/api/Event/CheckExternalEventSchedule`, {eventId: eventId});
    }

    public copyEvent(request: CopyEventRequest) {
        return super.post<CopyEventResponse>(`/api/Event/CopyEvent`, request);
    }

    public createAdHocEvent(createEventRequest: CreateEventRequest) {
        return super.post<CreateAdHocEventResponse>(`/api/Event/CreateAdHocEvent`, createEventRequest);
    }

    public createDraftEvent(request: CreateDraftEventRequest) {
        return super.post<CreateDraftEventResponse>(`/api/Event/CreateDraftEvent`, request);
    }

    public deleteBatchEvents(request: DeleteBatchEventRequest) {
        return super.post<SuccessResponse>(`/api/Event/DeleteBatchEvents`, request);
    }

    public deleteEvent(deleteEventRequest: DeleteEventRequest) {
        return super.post<void>(`/api/Event/DeleteEvent`, deleteEventRequest);
    }

    public downloadEventAttachment_Url(eventId: string, eventAttachmentId: string) {
        return super.getUrl(`/api/Event/DownloadEventAttachment`, {eventId: eventId, eventAttachmentId: eventAttachmentId});
    }

    public getEventById(eventId: string) {
        return super.get<Event>(`/api/Event/GetEventById`, {eventId: eventId});
    }

    public getEventByScenarioRecordingId(scenarioRecordingId: string) {
        return super.get<Event>(`/api/Event/GetEventByScenarioRecordingId`, {scenarioRecordingId: scenarioRecordingId});
    }

    public getEventByTrainingSessionId(trainingSessionId: string) {
        return super.get<Event>(`/api/Event/GetEventByTrainingSessionId`, {trainingSessionId: trainingSessionId});
    }

    public getEventCalendarExport_Url(eventId: string) {
        return super.getUrl(`/api/Event/GetEventCalendarExport`, {eventId: eventId});
    }

    public getEventDetailById(eventId: string, sessionState: SessionState = null) {
        return super.get<GetEventDetailByIdResponse>(`/api/Event/GetEventDetailById`, {eventId: eventId, sessionState: sessionState});
    }

    public getExamEventAssessmentCategoryOverview(eventId: string[]) {
        return super.get<void>(`/api/Event/GetExamEventAssessmentCategoryOverview`, {eventId: eventId});
    }

    public getExamEventAssessmentOverview_Url(eventIds: string[]) {
        return super.getUrl(`/api/Event/GetExamEventAssessmentOverview`, {eventIds: eventIds});
    }

    public getOutlookCalendars(userId: string) {
        return super.get<any[]>(`/api/Event/GetOutlookCalendars`, {userId: userId});
    }

    public listEvents(listEventsRequest: ListEventsRequest) {
        return super.post<ListData<Event>>(`/api/Event/ListEvents`, listEventsRequest);
    }

    public listEventsForExamArchive(searchTermName: string = null, searchTermDescription: string = null, sortColumn: string = "name", sortAscending: boolean = true, from: Date | string = null, to: Date | string = null, commaSeparatedEventStates: string = null, ownerId: string = null, scenarioId: string = null, commaSeparatedUserIds: string = null, commaSeparatedTrainingRoomIds: string = null, showFavoritesOnly: boolean = false, page: number = 0, pageSize: number = 2147483647) {
        return super.get<ListData<Event>>(`/api/Event/ListEventsForExamArchive`, {searchTermName: searchTermName, searchTermDescription: searchTermDescription, sortColumn: sortColumn, sortAscending: sortAscending, from: from, to: to, commaSeparatedEventStates: commaSeparatedEventStates, ownerId: ownerId, scenarioId: scenarioId, commaSeparatedUserIds: commaSeparatedUserIds, commaSeparatedTrainingRoomIds: commaSeparatedTrainingRoomIds, showFavoritesOnly: showFavoritesOnly, page: page, pageSize: pageSize});
    }

    public listEventsForScenarioRecordingSelection(searchTermName: string = null, searchTermDescription: string = null, sortColumn: string = "name", sortAscending: boolean = true, from: Date | string = null, to: Date | string = null, commaSeparatedEventStates: string = null, ownerId: string = null, scenarioId: string = null, commaSeparatedUserIds: string = null, commaSeparatedTrainingRoomIds: string = null, showFavoritesOnly: boolean = false, containsScenarioRecording: boolean = true, page: number = 0, pageSize: number = 2147483647) {
        return super.get<ListData<Event>>(`/api/Event/ListEventsForScenarioRecordingSelection`, {searchTermName: searchTermName, searchTermDescription: searchTermDescription, sortColumn: sortColumn, sortAscending: sortAscending, from: from, to: to, commaSeparatedEventStates: commaSeparatedEventStates, ownerId: ownerId, scenarioId: scenarioId, commaSeparatedUserIds: commaSeparatedUserIds, commaSeparatedTrainingRoomIds: commaSeparatedTrainingRoomIds, showFavoritesOnly: showFavoritesOnly, containsScenarioRecording: containsScenarioRecording, page: page, pageSize: pageSize});
    }

    public removeAttachment(request: RemoveEventAttachmentRequest) {
        return super.post<RemoveEventAttachmentResponse>(`/api/Event/RemoveAttachment`, request);
    }

    public removeSessionFromEvent(eventId: string, sessionId: string) {
        return super.post<void>(`/api/Event/RemoveSessionFromEvent/${encodeURIComponent(eventId)}/remove-session/${encodeURIComponent(sessionId)}`, {});
    }

    public searchOutlookUsers(searchQuery: string) {
        return super.get<any[]>(`/api/Event/SearchOutlookUsers`, {searchQuery: searchQuery});
    }

    public sendMail(request: SendEventEmailRequest) {
        return super.post<void>(`/api/Event/SendMail`, request);
    }

    public triggerSyncExternalEvents() {
        return super.get<void>(`/api/Event/TriggerSyncExternalEvents`, );
    }

    public updateEventName(updateEventNameRequest: UpdateEventNameRequest) {
        return super.post<void>(`/api/Event/UpdateEventName`, updateEventNameRequest);
    }
/**
 * Update the owner of an event, all its sessions and scenario recordings
 */ 

    public updateOwnerOfEvent(request: UpdateOwnerOfEventRequest) {
        return super.post<void>(`/api/Event/UpdateOwnerOfEvent`, request);
    }

    public upSertEvent(upSertEventRequest: UpSertEventRequest) {
        return super.post<SuccessResponse>(`/api/Event/UpSertEvent`, upSertEventRequest);
    }

    public upSertEventState(upSertEventStateRequest: UpSertEventStateRequest) {
        return super.post<void>(`/api/Event/UpSertEventState`, upSertEventStateRequest);
    }
/**
 * Check if Sessions would fall outside the TimeSpan of the Event
 */ 

    public validateUpSertEventSessionsOutsideDataRange(request: ValidateUpSertEventRequest) {
        return super.post<SimSession[]>(`/api/Event/ValidateUpSertEventSessionsOutsideDataRange`, request);
    }
}